// extracted by mini-css-extract-plugin
export default {"container":"WutY59G9Y63TBzJ6Th17","logo":"GG7fxh9ezHgBy6OCxAMv"};